import { FooterRow } from "./style.components";

const FixedFooter = () => {
  return <FooterRow>© Heme Health 2023, All rights reserved.</FooterRow>;
};

export default FixedFooter;
